import { BrandedEmailSettingsMapper } from './BrandedEmailSettingsMapper.js';

class BrandedEmailsSettingsRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getBrandedEmailsSettings() {
    return this.apiClient.get('v1/mailer/branded-email-settings-summary').then(response => BrandedEmailSettingsMapper.createBrandedEmailSettingsFromResponse(response.data));
  }
  toggle(emailType, toggle) {
    return this.apiClient.patch(`v1/mailer/branded-email-settings/${emailType}`, {
      active: toggle
    }).then(response => BrandedEmailSettingsMapper.createEmailsModel(response.data));
  }
  uploadLogo(file) {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiClient.post('v1/mailer/branded-email-settings-logo', formData).then(response => response.data);
  }
  createSettings(templateParams) {
    return this.apiClient.post('v1/mailer/branded-email-settings', getSettingsRequestParams(templateParams)).then(response => BrandedEmailSettingsMapper.createBrandedSettingsModel(response.data));
  }
  updateSettings(templateParams) {
    return this.apiClient.put('v1/mailer/branded-email-settings', getSettingsRequestParams(templateParams)).then(response => BrandedEmailSettingsMapper.createBrandedSettingsModel(response.data));
  }
  async saveSettings(_ref, isNewSettings) {
    let {
      companyName,
      companyReplyToEmail,
      companyLogo
    } = _ref;
    const getLogoUrl = async logo => {
      if (!logo || typeof logo === 'string') return logo;
      const response = await this.uploadLogo(logo);
      return response.url;
    };
    const params = {
      companyName,
      companyReplyToEmail,
      companyLogoUrl: await getLogoUrl(companyLogo)
    };
    return isNewSettings ? this.createSettings(params) : this.updateSettings(params);
  }
}
function getSettingsRequestParams(_ref2) {
  let {
    companyName,
    companyLogoUrl,
    companyReplyToEmail
  } = _ref2;
  return {
    company_name: companyName,
    // To delete values we need to send undefined, "" (empty string) would fail.
    company_reply_to_email: companyReplyToEmail || undefined,
    company_logo_url: companyLogoUrl || undefined
  };
}

export { BrandedEmailsSettingsRepository };
//# sourceMappingURL=BrandedEmailSettingsRepository.js.map
